import React from 'react';
import Router from './Router';

export default () => (
  <div>
    <Router />
  </div>
);
